const gql = {
  query: `
    mutation DeleteBank($input: DeleteBankInput!) {
        deleteBank(input: $input) {
          success
          messages{
            errorCode
            errorMessage
          }
        }
    }`,
  variables: {
    input: {
      taBankInfo: null,
    },
  },
  meta: {
    label: "Delete Bank",
  },
};

export default gql;
